const VIEW_TYPE_FEED = 'feed'

export default {
  canDelete: false,
  canFlag: false,
  canPost: false,
  currentUser: null,
  pagination: {
    currentPage: 1,
    totalPages: null
  },
  threads: [],
  viewType: VIEW_TYPE_FEED
}
